<div *nzModalTitle></div>
<div>
  <div class="relative px-6 flex justify-center text-[#2C3035] md:text-[1rem] md:text-[1.125rem] font-bold">
    {{ 'balance.transactionStatus' | translate }}
    <i class="absolute top-2 right-2 cursor-pointer" (click)="close()">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path
          d="M6 4.66688L10.6669 0L12 1.33312L7.33312 6L12 10.6669L10.6669 12L6 7.33312L1.33312 12L0 10.6669L4.66688 6L0 1.33312L1.33312 0L6 4.66688Z"
          fill="#2C3035"
        />
      </svg>
    </i>
  </div>

  @if (isLoading()) {
    <div class="px-6 py-8">
      <korviu-loader />
    </div>
  } @else {
    <div class="px-2 py-2 flex flex-col items-center md:gap-6 gap-5">
      <div class="text-[#2C3035] text-[1.1875rem] md:text-[1.375rem] font-bold">
        @if (isReimburse) {
          {{ currentLang === 'en' ? transaction?.name_en : transaction?.name_es }}
        }
        @if (isPurchase) {
          {{ 'balance.giftCard' | translate }}
        }
        @if (isTransfer) {
          @if (isAmountPositive) {
            {{ 'balance.transferFrom' | translate }} {{ counterpartName }}
          }
          @if (isAmountNegative) {
            {{ 'balance.transferTo' | translate }} {{ counterpartName }}
          }
        }
        @if (isDeposit) {
          {{ 'balance.ganasDeposit' | translate }}
        }
        @if (!isReimburse && !isPurchase && !isTransfer && !isDeposit) {
          {{ currentLang === 'en' ? transaction?.name_en : transaction?.name_es }}
        }
      </div>

      <div class="flex flex-row gap-2 items-center">
        <div class="text-[#2C3035] md:text-[1.125rem] text-[1rem]">{{ 'balance.status' | translate }}:</div>
        <app-tag [type]="statusTagType">
          {{ statusDisplay }}
        </app-tag>
      </div>

      <div class="w-full">
        <div class="bg-[#E6F2FA] px-6 py-2 rounded-t-[1rem]">
          <div class="text-[#2C3035] md:text-[0.9375rem] text-[0.8125rem] font-bold">
            {{ 'balance.transactionDetails' | translate }}
          </div>
        </div>

        <div class="border-l-1 border-r-1 border-solid border-[#EEEEEF]">
          @if (hasTransactionId) {
            <div
              class="px-6 py-2 h-[3.5rem] flex items-center text-[#393E44] md:text-[0.9375rem] text-[0.8125rem] font-bold"
            >
              {{ 'balance.transactionId' | translate: { id: detail?.id || transaction.id } }}
            </div>
          }

          <div class="grid grid-cols-2">
            @for (field of fields(); track field.title) {
              <div class="px-6 py-2 h-[3.5rem] text-[#393E44] md:text-[0.9375rem] text-[0.8125rem] flex items-center">
                {{ field.title | translate }}
              </div>
              <div class="px-6 py-2 h-[3.5rem] text-[#393E44] text-[0.9375rem] flex items-center">
                @if (field.translateValue) {
                  {{ field.value | translate }}
                } @else {
                  {{ field.value }}
                }
              </div>
            }
          </div>
        </div>

        <div class="rounded-b-[1rem] border-1 border-solid border-[#EEEEEF] h-[3.5rem] grid grid-cols-2 items-center">
          <div
            class="px-6 py-2 h-[3.5rem] text-[#393E44] md:text-[0.9375rem] text-[0.8125rem] font-bold flex items-center"
          >
            {{ 'balance.amount' | translate }}
          </div>
          <div
            class="px-6 py-2 h-[3.5rem] text-[#393E44] md:text-[0.9375rem] text-[0.8125rem] font-bold flex items-center"
          >
            {{ amountDisplay }}
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div *nzModalFooter></div>
